export default {
    header: 'Resources',
    resourceTypeHeader: 'Type',
    resourceNoContent:
        'Your school has not yet activated the resource function.',
    resourceFolderNoContent: 'There are no available resources in this folder',
    resourceTitleHeader: 'Title',
    resourcePublishDateHeader: 'Published',
    searchPlaceholder: 'Search for name or keyword ...',
};
